(function ($) {
  window.winWidthChangedEvent = 'cdz_winwidth_changed';
  var $body = $('body'), rtl = $body.hasClass('rtl-layout'), win = window, $win = $(win), custEl = customElements, breakpoint = 768, mdBreakpoint = 992,
    svgIcon = function (id) {
      return '<svg><use href="#' + id + '"></use></svg>';
    }
  win.scrollbarWidth = null; 
  var updateSection = function (res, section, element) {
    if (res.sections && res.sections[section]) {
      var $new = $(res.sections[section]); element.replaceWith($new.children()); $new.remove();
    }
  }
  /* Slider */
  class CdzSlider {
    screens = [1200, 992, 768, 576, 0];
    constructor(element) {
      this.element = $(element);
      var self = this, gap = parseFloat(this.element.css('--items-gap')), data;
      this.data = { breakpoints: {}, spaceBetween: gap };
      $.each(this.screens, function (i, screen) {
        var items = parseFloat(self.element.css('--items-' + screen));
        self.data.breakpoints[screen] = { slidesPerView: items };
        if (screen < 768) {
          self.data.breakpoints[screen].spaceBetween = Math.min(10, gap);
        }
      });
      this.data.slidesPerView = self.data.breakpoints[1200].slidesPerView;
      if (data = this.element.data('slider')) {
        this.data = $.extend(this.data, data);
      }
      this.prepareHtml();
      this.slider = new Swiper(this.element.get(0), this.data);
    }
    prepareHtml() {
      var conf = this.data, $el = this.element.removeClass('cdz-grid-base').addClass('swiper slider-loaded'),
        $wrap = $('<div class="swiper-wrapper">').appendTo($el);
      $wrap.siblings().appendTo($wrap).addClass('swiper-slide');
      if (conf.dots) {
        $el.append('<div class="swiper-pagination">');
        conf.pagination = { el: ".swiper-pagination", clickable: true };
      }
      if (conf.nav) {
        $el.append('<div class="slider-btn swiper-button-prev">').append('<div class="slider-btn swiper-button-next">');
        conf.navigation = { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" };
      }
      if (conf.autoplay) {
        var delay = conf.delay ? parseInt(conf.delay) : 10000;
        conf.autoplay = {
          delay: delay,
          disableOnInteraction: false
        }
      }
    }
  }
  if (!custEl.get('cdz-grid')) {
    custEl.define('cdz-grid', class CdzGrid extends HTMLElement {
      constructor() {
        super();
        var $slider = $(this).find('.cdz-slider').first();
        if ($slider.length) {
          new CdzSlider($slider.get(0));
        }
      }
    });
  }
  /* Tabs */
  class CdzTabs {
    constructor(element) {
      this.element = $(element);
      var self = this, $titleWrap = this.element.find('.tab-titles').first(), tt,
      $mbTitle = $('<div class="mb-tab-titles d-block d-md-none">').insertBefore($titleWrap),
      $titles = $('[role="tab_title"]', $titleWrap), toggleTitles = (open) => {
          var toggle = open ? 'addClass' : 'removeClass';
          $mbTitle[toggle]('active');
          $titleWrap[toggle]('tt-active');
      };
      $titles.each(function (i, el) {
        var $title = $(el), $tab = $('.tab-contents > [role="tab_content"]:eq(' + i + ')', self.element);
        $title.on('click', function (e) {
          e.preventDefault();
          $title.addClass('active').siblings().removeClass('active');
          $tab.addClass('active').siblings().removeClass('active');
          if (tt) clearTimeout(tt);
          tt = setTimeout(() => { $win.trigger('cdzTabOpened', [$tab]); }, 100);
          $mbTitle.text($title.text());
          toggleTitles(false);
        });
      });
      $mbTitle.text($titles.first().text()).on('click', function() {
        toggleTitles($mbTitle.toggleClass('active').hasClass('active'));
      });
      $body.on('click', function(e) {
        var $tg = $(e.target);
        if (!($mbTitle.has($tg).length || $mbTitle.is($tg))) {
            toggleTitles(false);
        }
      });
    }
  }
  if (!custEl.get('cdz-block-moved')) {
      custEl.define('cdz-block-moved', class CdzBlockMoved extends HTMLElement {
          constructor() {
            super();
            var $dest = $(this), $source = $($dest.attr('data-blockmoved'));
            if ($source.length) $source.first().insertAfter($dest);
            $dest.remove();
          }
      });
  }
  if (!custEl.get('cdz-tabs')) {
    custEl.define('cdz-tabs', class CdzHtmlTabs extends HTMLElement {
      constructor() {
        super();
        new CdzTabs(this);
      }
    });
  }
  /*** Core ***/
  class CdzCore {
    constructor() {
      var self = this, t = false;
      win.scrollbarWidth = this.getScrollbarWidth();
      this.windowResize();
      this.prepareCSSVars();
      this.dropdown();
      this.generatePopup();
      this.generateSidebar();
      this.addSidebarContent();
      this.slider();
      this.$gbLoader = $('#cdz-gb-loader');
      this.mobiToggle();
      if (!this.$gbLoader.length) {
        $('<div id="cdz-gb-loader" class="cdz-gb-loader">').html(svgIcon('cdz-icon-loader')).appendTo('body').hide();
        this.$gbLoader = $('#cdz-gb-loader');
      }
      if (window.innerWidth < breakpoint) {
        this.prepareMobi();
      }
      if (window.innerWidth < mdBreakpoint) {
        this.prepareMdDown();
      }
      this.vermenu();
      this.responsive();
      $win.on('cdz_mobile', self.prepareMobi.bind(this)).on('cdz_desktop', self.prepareDesk.bind(this))
        .on('cdz_md_up', self.prepareMdUp.bind(this)).on('cdz_md_down', self.prepareMdDown.bind(this))
        .on(winWidthChangedEvent, self.responsive.bind(this)).on('cdzTabOpened', function (e, $tab) {
          self.alignHeight($tab);
        });
    }
    responsive() {
      this.alignHeight();
      this.copyHeight();
    }
    prepareDesk() {
      this.prepareCSSVars();
      this.move('id-mobi', 'id-desk');
    }
    prepareMobi() {
      this.prepareCSSVars();
      this.move('id-desk', 'id-mobi');
    }
    prepareMdUp() {
      this.move('id-mddown', 'id-mdup');
    }
    prepareMdDown() {
      this.move('id-mdup', 'id-mddown');
    }
    windowResize() {
      var ww = window.innerWidth, t;
      $win.on('resize', function () {
        if (t) clearTimeout(t);
        t = setTimeout(() => {
          if (window.innerWidth != ww) {
            ww = window.innerWidth;
            $win.trigger(winWidthChangedEvent, [ww]);
            if (ww >= breakpoint) {
              $win.trigger('cdz_desktop', [ww]);
            } else {
              $win.trigger('cdz_mobile', [ww]);
            }
            if (ww >= mdBreakpoint) {
              $win.trigger('cdz_md_up', [ww]);
            } else {
              $win.trigger('cdz_md_down', [ww]);
            }
          }
        }, 50)
      });
    }
    mobiToggle() {
      $body.on('click', '[role="mbtg-trigger"]', function (e) {
        if (window.innerWidth < breakpoint) {
          e.preventDefault();
          let $pr = $(this).parents('[role="tg-box"]').first();
          $pr.toggleClass('active').find('[role="tg-content"]').slideToggle(400, 'swing', function () {
            !$pr.hasClass('active') ? $(this).css('display', '') : '';
          });
        }
      });
    }
    vermenu() {
      $body.on('click', '[role="vmenu_title"]', function (e) {
        e.preventDefault();
        var $title = $(this), $wrap = $title.parents('[role="vmenu_wrap"]').first();
        $wrap.toggleClass('cdz-vmenu-open');
      }).on('click', function (e) {
        if (!$('.mb-vmenu-wrap .cdz-vmenu-open').length) {
          var $target = $(e.target);
          if (!($target.hasClass('cdz-vmenu-open') || ($target.parents('.cdz-vmenu-open').length))) {
            $('.cdz-vmenu-open').removeClass('cdz-vmenu-open');
          }
        }
      });
    }
    move(fromPrefix, toPrefix) {
      $('[' + fromPrefix + ']').each(function () {
        let $element = $(this), $children = $element.children(),
          id = $element.attr(fromPrefix), $to = $('[' + toPrefix + '="' + id + '"]').first();
        if ($to.length) $children.appendTo($to);
      });
    }
    slider() {
      $('.cdz-slider').each(function () {
        if (!$(this).hasClass('slider-loaded')) new CdzSlider(this);
      });
    }
    prepareCSSVars() {
      var self = this, $css;
      $body.css({
        '--gb-scrollbar-w': self.getScrollbarWidth() + 'px'
      });
    }
    getScrollbarWidth() {
      var $outer = $('<div>').css({ visibility: 'hidden', width: 100, overflow: 'scroll' }).appendTo('body'),
        width = $('<div>').css({ display: 'block', width: '100%' }).appendTo($outer).width();
      $outer.remove();
      return 100 - width;
    }
    generateSidebar() {
      if ($('#cdz-sb-wrap').length === 0) {
        var self = this, $sb = $('<div class="cdz-sb-wrap" id="cdz-sb-wrap"></div>').appendTo('body'),
          $bf = $('<div class="cdz-sb-backface" role="hbclosesidebar">').appendTo($sb);
        this.sidebar['left'] = $('<div class="cdz-sidebar cdz-sb-left cdz-scroll" id="cdz-sb-left" data-side="left">').appendTo($sb),
          this.sidebar['right'] = $('<div class="cdz-sidebar cdz-sb-right cdz-scroll" id="cdz-sb-right" data-side="right">').appendTo($sb);
        $body.on('click', '[data-opensidebar]', function (e) {
          e.preventDefault();
          self.openSidebar($(this).data('opensidebar'));
        });
        $body.on('click', '[role=hbclosesidebar]', function () {
          self.closeSidebar();
        });
      }
    }
    addSidebarContent() {
      var self = this;
      $('[cdz-sidebar]').each(function () {
        var $sb = $(this), side = $sb.data('side');
        self.sidebar($sb.removeAttr('cdz-sidebar').removeClass('hidden'), (side ? side : 'left'), null);
      });
    }
    sidebar(sidebar, side, trigger) {
      if (rtl) side = (side == 'right') ? 'left' : 'right';
      var $side = this.sidebar[side], $wrap = $('<div class="cdz-sb-content">').appendTo($side), $sb = $(sidebar).appendTo($wrap);
      if (trigger) {
        $(trigger).on('click', function (e) {
          e.preventDefault(); hc.openSidebar($sb);
        }).removeAttr('data-opensidebar');
      }
    }
    openSidebar(sidebar) {
      var $sb = $(sidebar), $wrap = $sb.parents('.cdz-sb-content').first(),
        $side = $sb.parents('.cdz-sidebar').first(), side = $side.data('side');
      $('html').addClass('cdz-sb-state side-' + side);
      setTimeout(function () {
        $('html').addClass('cdz-sb-open');
      }, 10);
      $wrap.addClass('active').siblings().removeClass('active');
    }
    closeSidebar() {
      $('html').removeClass('cdz-sb-open');
      $('#cdz-sb-wrap .cdz-sb-content.active').removeClass('active');
      setTimeout(function () {
        $('html').removeClass('cdz-sb-state side-left side-right');
      }, 310);
    };
    dropdown() {
      var $curDrop = null;
      $body.on('click', '[role="cdz-drop-link"]', function (e) {
        e.preventDefault();
        let $a = $(this), $drop = $a.parents('[role="cdz-drop"]').first(), $cont = $('[role="cdz-drop-content"]', $drop).first();
        $drop.toggleClass('cdz-active');
        if ($drop.hasClass('cdz-active')) {
          if ($curDrop && !($curDrop.is($drop) || $curDrop.has($drop).length || $drop.has($curDrop).length)) {
            var $ctPr = $curDrop.parents('[role="cdz-drop-content"]').last();
            if ($ctPr.length && (!($ctPr.has($drop).length))) {
              $ctPr.parents('[role="cdz-drop"]').first().removeClass('cdz-active');
            } else {
              $curDrop.removeClass('cdz-active');
            }
          }
          $curDrop = $drop;
          let w = $cont.outerWidth(), start = parseFloat($cont.css('inset-inline-start')),
            oLeft = rtl ? window.innerWidth - $cont.offset().left - w : $cont.offset().left
          if (Math.abs(start) >= 0) {
            (oLeft + w > window.outerWidth) ? $cont.css({ 'inset-inline-start': -(oLeft + w - window.outerWidth) - scrollbarWidth + start - 10 }) : '';
          } else if (Math.abs(parseFloat($cont.css('inset-inline-end'))) >= 0) {
            (oLeft < 0) ? $cont.css({ 'inset-inline-end': oLeft }) : '';
          }
        } else {
          var $ctPr = $drop.parents('[role="cdz-drop-content"]').first();
          $cont.css({ 'inset-inline-start': '', 'inset-inline-end': '' });
          $curDrop = $ctPr.length ? $ctPr.parents('[role="cdz-drop"]').first() : null;
        }
      }).on('click', function (e) {
        if ($curDrop) {
          var $target = $(e.target), $ctPr = $target.parents('[role="cdz-drop-content"]').first(),
            $context = $ctPr.length ? $ctPr : $body,
            $drop = $('[role="cdz-drop"].cdz-active', $context).first();
          if ($drop.length && !($drop.is($target) || $drop.has($target).length)) {
            $drop.removeClass('cdz-active').find('[role="cdz-drop-content"]').first().css({ 'inset-inline-start': '', 'inset-inline-end': '' });
            $curDrop = $ctPr.length ? $ctPr.parents('[role="cdz-drop"]') : null;
          }
        }
      });
    }
    generatePopup() {
      var self = this;
      if ($.fn.cdzPopup == undefined) {
        $.fn.extend({
          cdzPopup: function (conf) {
            return this.each(function () {
              self.popup(conf, $(this));
            });
          },
          openCdzPopup: function (conf) {
            return this.each(function () {
              if (typeof this.openCdzPopup == 'function') {
                this.openCdzPopup();
              }
            });
          }
        })
      }
      $body.off('click.openCdzPopup').on('click.openCdzPopup', '[data-openpopup]', function (e) {
        e.preventDefault();
        var $popup = $($(this).data('openpopup'));
        if ($popup.length) $popup.openCdzPopup();
      });
    }
    popup(conf, $element) {
      var $wrap = $('<div class="cdz-popup">').appendTo('body'),
        $bf = $('<div class="cdz-backface" role="close-popup">').appendTo($wrap),
        $inner = $('<div class="cdz-inner">').appendTo($wrap),
        $close = $('<button class="cdz-pp-close" role="close-popup">').appendTo($inner).html(svgIcon('icon-close')),
        $content = $('<div class="cdz-pp-content">').appendTo($inner);
      if (conf.title) $('<div class="cdz-pp-header">').insertBefore($content).html(conf.title);
      if (conf.wrapClass) $wrap.addClass(conf.wrapClass);
      if (conf.id) $wrap.attr('id', conf.id);
      var el = $element.appendTo($content).get(0);
      el.openCdzPopup = () => {
        $body.addClass('cdz-pp-opened');
        $wrap.addClass('cdz-opened cdz-pp-state');
        if (typeof conf.openCallback == 'function') conf.openCallback();
      }
      el.closeCdzPopup = () => {
        $wrap.removeClass('cdz-pp-state');
        setTimeout(() => {
          $wrap.removeClass('cdz-opened');
          if (!$('.cdz-popup.cdz-opened').length) $body.removeClass('cdz-pp-opened');
          if (typeof conf.closeCallback == 'function') conf.closeCallback();
        }, 600);
      }
      $wrap.on('click', '[role=close-popup]', () => {
        el.closeCdzPopup();
      });
      if (conf.autoOpen) el.openCdzPopup();
    }
    showLoader() {
      this.$gbLoader.show();
    }
    hideLoader() {
      this.$gbLoader.hide();
    }
    getColorMap() {
      if (typeof this.colorMap == 'undefined') {
        var self = this;
        this.colorMap = {};
        var $colorJs = $('#cdz-color-mapping');
        if ($colorJs.length) {
          var colors = JSON.parse($colorJs.html());
          $.each(colors, function (i, color) {
            self.colorMap[color.title] = color;
          });
        }
      }
      return this.colorMap;
    }
    alignHeight($context) {
      if (typeof $context == 'undefined') $context = $body;
      $('[data-sameheight]', $context).each(function () {
        var $el = $(this);
        if ($el.is(':visible')) {
          var sameHeightArray = $el.data('sameheight').split(',');
          $.each(sameHeightArray, function (i, sameHeight) {
            var maxHeight = 0;
            $el.find(sameHeight).css({ minHeight: '' }).each(function () {
              let $sItem = $(this), height = ($sItem.css('box-sizing') === 'content-box') ? $sItem.height() : $sItem.outerHeight();
              if (height > maxHeight) {
                maxHeight = height;
              }
            }).css({ minHeight: maxHeight });
          });
        }
      });
    }
    copyHeight($context) {
      if (typeof $context == 'undefined') $context = $body;
      $('[data-copyheight]', $context).each(function () {
        var $el = $(this).css('height', '').removeClass('height-copied'), $source = $($el.data('copyheight')).first();
        if ($source.length && $source.is(':visible')) {
          var sH = $source.outerHeight(), elH = $el.css('display', 'flex').outerHeight();
          $el.css('height', sH);
          if (elH >= sH) $el.addClass('height-copied');
          $el.css('display', '');
        }
      });
    }
  }
  if (typeof window.cdzCore == 'undefined') window.cdzCore = new CdzCore();
  if (!custEl.get('cdz-popup-content')) {
    custEl.define('cdz-popup-content', class CdzPopupContent extends HTMLElement {
      constructor() {
        super();
        var $popup = $(this).cdzPopup(this.dataset), id = $popup.attr('id');
      }
    });
  }
  /*** Product management functions ***/
  if (!custEl.get('cdz-product-form')) {
    custEl.define('cdz-product-form', class CdzProductForm extends HTMLElement {
      constructor() {
        super();
        this.element = $(this);
        this.$form = this.element.find('form');
        this.$form.find('[name=id]').removeAttr('disabled');
        this.$button = this.$form.find('[role="tocart"]');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.bindEvents();
      }
      bindEvents() {
        var self = this;
        this.$form.on('submit', (e) => {
          e.preventDefault();
          self.ajaxAddToCart();
        });
      }
      ajaxAddToCart() {
        this.beforeAddToCart();
        var self = this, formData = new FormData(this.$form[0]), sections = [];
        if (this.cart) {
          sections = this.cart.getSectionsToRender().map((section) => section.id);
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        formData.append('sections', sections);
        $.ajax({
          url: this.$form.attr('action'),
          data: formData,
          type: 'post',
          dataType: 'json',
          cache: false,
          contentType: false,
          processData: false,
          success: function (res) {
            self.afterAddToCart(res);
          }, fail: function (res) {
            console.log(res);
          }
        }).always(function (res) {
          self.$button.removeAttr('disabled');
          if (res.statusText == 'error') alert(res.responseJSON.errors);
        });
      }
      beforeAddToCart() {
        this.$button.attr('disabled', 'disabled');
      }
      afterAddToCart(res) {
        this.cart.renderContents(res);
      }
    });
  }
  if (!custEl.get('cdz-minicart')) {
    custEl.define('cdz-minicart', class CdzMinicart extends HTMLElement {
      constructor() {
        super();
        this.element = $(this);
        this.bindEvents();
      }
      bindEvents() {
        var self = this;
        this.element.on('click', '[role="remove"]', function (e) {
          e.preventDefault();
          self.updateItem($(this).parents('[role="cart_item"]').first(), 0);
        }).on('change', '[role=num]', function (e) {
          var $qty = $(this), qty = parseFloat($qty.val());
          if (!isNaN(qty)) self.updateItem($(this).parents('[role="cart_item"]').first(), qty);
        });
      }
      updateItem($item, qty) {
        if (!$item.hasClass('processing')) {
          var self = this, id = $item.addClass('processing').data('id'),
            data = {
              id: id,
              quantity: qty,
              sections: 'cdz-minicart',
              sections_url: window.location.pathname
            };
          $.ajax({
            url: window.routes.cart_change_url,
            data: data,
            type: 'post',
            cache: false,
            dataType: 'json',
            success: function (res) {
              $item.removeClass('processing');
              updateSection(res, 'cdz-minicart', self.element);
            }
          });
        }
      }
    });
  }
  if (!custEl.get('cdz-quickview')) {
    custEl.define('cdz-quickview', class CdzQuickview extends HTMLElement {
      constructor() {
        super();
        var self = this;
        this.element = $(this);
        this.$qvModal = $('#cdz-quickview-modal');
        if (!this.$qvModal.length) {
          this.$qvModal = $('<div id="cdz-quickview-modal">').appendTo('body');
          this.$qvModal.cdzPopup({
            closeCallback: () => {
              self.$qvModal.empty();
            }
          });
        }
        this.element.on('click', (e) => {
          self.loadProduct(self.element.attr('href'));
        });
      }
      preventVariantURLSwitching() {
        $('variant-radios,variant-selects', this.$qvModal).attr('data-update-url', 'false');
      }
      loadProduct(url) {
        var self = this;
        cdzCore.showLoader();
        $.ajax({
          url: url + '?view=quickview',
          type: 'get',
          success: function (res) {
            cdzCore.hideLoader();
            self.$qvModal.html(res).openCdzPopup();
            self.preventVariantURLSwitching();
            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();
          }
        })
      }
    });
  }
  if (!custEl.get('cdz-variants')) {
    custEl.define('cdz-variants', class CdzVariants extends VariantSelects {
      constructor() {
        super();
        this.element = $(this);
        this.isMain = this.element.data('ismain');
        this.prepareHtml();
        this.$product = this.element.parents('.product-item').first();
      }
      prepareHtml() {
        var colorMap = window.cdzCore.getColorMap(), bkg, self = this;
        this.element.find('fieldset.swatch-color').each(function () {
          var $opt = $(this).addClass('swatch-color');
          $opt.find('[type="radio"]').each(function () {
            var $ip = $(this), val = $ip.val(), match = colorMap[val];
            if (match) {
              bkg = '';
              if (match.color) bkg += ' ' + match.color;
              if (match.background) bkg += ' url("' + match.background + '")';
              $ip.parents('.cdz-swatch').first().css('--gb-sw-bkg', bkg);
            }
          });
        });
        this.element.find('[type="radio"]:checked').each(function () {
          var $active = $(this);
          $active.parents('.cdz-swatch').first().addClass('active');
          self.element.find('[data-for="' + $active.attr('name') + '"]').first().find('[role="selected_option"]').text($active.val());
        });
        this.element.tooltip({
          items: "[title]",
          position: { my: "center bottom-5", at: "center top" },
          content: function () {
            var $sw = $(this), title = $sw.attr('title'), style = $sw.attr('style');
            if ($sw.parents('.swatch-color').length) {
              return '<div class="cdz-tooltip sw-tooltip" style=\'' + style + '\'><div class="sw-bkg"></div><div class="sw-label">' + title + '</div></div>';
            }
            return '<div class="cdz-tooltip">' + title + '</div>';
          }
        });
      }
      updateOptions() {
        this.options = Array.from(this.querySelectorAll('fieldset')).map((fieldset) => {
          var $active = $(fieldset).find('[type="radio"]:checked').first();
          if (!$active.length) {
            $active = $(fieldset).find('[type="radio"][checked]').first();
            if (!$active.length) {
              $active = $(fieldset).find('[type="radio"]').first();
            }
          }
          $active.parents('.cdz-swatch').addClass('active').siblings().removeClass('active');
          this.element.find('[data-for="' + $active.attr('name') + '"]').first().find('[role="selected_option"]').text($active.val());
          return $active.val();
        });
      }
      updateVariantInput() {
        if (this.isMain) {
          super.updateVariantInput();
        } else {
          var self = this;
          this.getProductForms().each(function () {
            $(this).find('input[name="id"]').val(self.currentVariant.id).trigger('change', { bubbles: true });
          });
        }
      }
      renderProductInfo() {
        if (this.isMain) {
          super.renderProductInfo();
        } else {
          var $cartBtn = this.$product.find('[data-type="add-to-cart-form"] [type="submit"]');
          if (!this.currentVariant.available) {
            $cartBtn.attr('disabled', 'disabled').find('span').first().text(window.variantStrings.unavailable);
          } else {
            $cartBtn.removeAttr('disabled').find('span').first().text(window.variantStrings.addToCart);;
          }
        }
      }
      getProductForms() {
        var $form = this.element.parents('form');
        if (!$form.length) {
          $form = this.$product.find('form[data-type="add-to-cart-form"]');
        }
        return $form;
      }
      getProductImage() {
        return this.$product.find('.product-image img').last();
      }
      updateMedia() {
        if (this.isMain) {
          super.updateMedia();
        } else {
          var $img = this.getProductImage();
          if (this.currentVariant && this.currentVariant.featured_image) {
            var img = this.currentVariant.featured_image.src + '&width=360';
            $img.attr('src', img).attr('srcset', img);
          }
        }
      }
      updateURL() {
        if (this.isMain) super.updateURL();
      }
    });
  }
  if (!custEl.get('cdz-tooltip')) {
    custEl.define('cdz-tooltip', class CdzTooltip extends HTMLElement {
      constructor() {
        super();
        this.element = $(this);
        this.prepareHtml();
      }
      prepareHtml() {
        var self = this;
        this.element.tooltip({
          items: this.element,
          position: { my: "center bottom-5", at: "center top" },
          content: function () {
            return '<div class="cdz-tooltip">' + self.element.attr('title') + '</div>';
          }
        });
      }
    });
  }
  if (!custEl.get('cdz-ajax-content')) {
    custEl.define('cdz-ajax-content', class cdzSticky extends HTMLElement {
      options = {cache: true}
      constructor() {
        super();
        var conf = $.extend(this.options, this.dataset), $element = $(this);
        if (conf.url) {
          $.ajax({
            url: conf.url,
            type: 'get',
            cache: conf.cache,
            async: true,
            success: (rs) => {
              var $pool = $(rs.replace(conf.url, document.URL));
              if (conf.selector) {
                $pool = $pool.find(conf.selector).first();
              }
              $element.replaceWith($pool);
            }
          })
        }
      }
    });
  }
  if (!custEl.get('cdz-sticky')) {
    custEl.define('cdz-sticky', class cdzSticky extends HTMLElement {
      options = {
        breakpoint: 768,
        activeClass: 'stiky-active',
        parent: 'header',
        threshold: 350,
        allowMove: true,
        allowAllDirs: true
      }
      constructor() {
        super();
        this.options = $.extend(this.options, this.dataset);
        this.element = $(this);
        this.prepareHtml();
      }
      prepareHtml() {
        var self = this, conf = this.options, hBreakpoint = conf.breakpoint,
          eType = 'headerStateChanged', activeClass = conf.activeClass, w = window.innerWidth,
          isSticky = false, curState = false, allow = true, allowMove = conf.allowMove && (w >= hBreakpoint),
          $parent = this.element.parents(conf.parent).first(),
          prHeight = $parent.outerHeight(), t = false, tc = false,
          threshold = (w < hBreakpoint) ? prHeight : conf.threshold, top = $win.scrollTop();
        $parent.css({ minHeight: prHeight });
        $win.on('scroll', () => {
          if (allow) {
            var newTop = $win.scrollTop();
            curState = (newTop > threshold) && (conf.allowAllDirs || (newTop < top));
            curState ? $parent.addClass(activeClass) : $parent.removeClass(activeClass);
            top = newTop;
            if (curState != isSticky) {
              $win.trigger(eType, [curState]);
              isSticky = curState;
            }
          }
        });
        $win.on(eType, function (e, isSticky) {
          if (tc) clearTimeout(tc);
          tc = setTimeout(() => {
            (isSticky && allowMove) ? cdzCore.move('id-hdmain', 'id-hdsticky') : cdzCore.move('id-hdsticky', 'id-hdmain');
          }, 30);
        });
        $win.on('resize', function () {
          if (t) clearTimeout(t);
          t = setTimeout(() => {
            var newWidth = window.innerWidth;
            if (w != newWidth) {
              w = newWidth;
              self.element.removeClass(activeClass);
              $parent.css({ minHeight: '' });
              cdzCore.move('id-hdsticky', 'id-hdmain');
              allow = false;
              $win.trigger(eType, [isSticky]);
              t = setTimeout(() => {
                prHeight = $parent.outerHeight();
                $parent.css({ minHeight: prHeight });
                threshold = (w < hBreakpoint) ? prHeight : conf.threshold;
                allow = true; allowMove = conf.allowMove && (w >= hBreakpoint);
                isSticky = $win.scrollTop() > threshold;
                if (isSticky && allowMove) {
                  cdzCore.move('id-hdmain', 'id-hdsticky');
                  $parent.addClass(conf.activeClass);
                  $win.trigger(eType, [isSticky]);
                }
              }, 300);
            }
          }, 30);
        });
      }
    });
  }
})(jQuery);